import { filterKeyArr, parseFacets, parseSearchFilter } from '../utils/search-utils';

let client = null;
let index = null;
let fetchingLib = false;
let libPromise = null;

export default class Search {
  static async getSearchIndex() {
    if (!client) {
      if (!fetchingLib) {
        fetchingLib = true;
        libPromise = import('algoliasearch').then(({ default: algoliasearch }) => {
          fetchingLib = false;
          client = algoliasearch(
            process.env.REACT_APP_CLIENT_ALGOLIA_APP_ID,
            process.env.REACT_APP_CLIENT_ALGOLIA_API_KEY,
          );
        });
      }
      await libPromise;
    }
    if (!index) {
      index = client.initIndex(process.env.REACT_APP_CLIENT_ALGOLIA_APP_NAME);
    }
    return index;
  }

  static async doSearch(query, params, filterObj) {
    const searchIndex = await Search.getSearchIndex();
    const filters = parseSearchFilter(filterObj);
    const facets = Object.keys(filterKeyArr);
    const facetResults = await searchIndex.search({ facets, hitsPerPage: 1, page: 0, query });
    const results = await searchIndex.search({ ...params, query, filters, facets });
    return {
      ...results,
      facets: parseFacets(results.facets, facetResults.facets, {
        instrument: filterObj.instrument || 'guitar',
      }),
    };
  }
}
